import React from 'react';
import {Typography} from 'antd';

import ContactUs from "./ContactUs";
import ErrorBoundary from "../../../components/ErrorBoundary";

const {Title} = Typography;

const ContactMain = () => (
    <ErrorBoundary>
        <Title level={3}>Contact</Title>
        <ContactUs/>
    </ErrorBoundary>
);

export default ContactMain;